import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import DoneTasks from "../Routes/ActiveMachines";
import Home from "../Routes/Home";
import SearchResults from "../Routes/SearchResults";
import HeaderTasks from "./HeaderTasks";
import MachineOnly from "../Routes/MachineOnly";
import TodaysMachines from "../Routes/TodaysMachines";
import DownloadStrategy from "../Utilities/DownloadStrategy";
import RootLayout from "./RootLayout";
import Logout from "../Utilities/Logout";
import { useMemberstack } from "@memberstack/react";
import DisclaimerDoc from "./DisclaimerDoc";

const RoutesSection: React.FC = () => {
  const [isSignedDoc, setIsSignedDoc] = useState(true);

  const handlOnIsDocSigned = (data:any) => {
    setIsSignedDoc(() => data.length>0 ? true: false);
  };
  return (
    <>
      <div className="md:w-auto w-full  ">
        <HeaderTasks />
     <DisclaimerDoc onIsDocSigned={handlOnIsDocSigned} onlyLoad={false}  />
      </div>
      <div className=" md:container sm:max-w-6xl md:max-w-full md:mx-auto">
        <RootLayout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/today" element={<TodaysMachines />} />
            <Route
              path="/active"
              element={<DoneTasks done={true} title="Active Machines" />}
            />
            <Route path="/results" element={<SearchResults />} />
            <Route path="/machine/:machineId" element={<MachineOnly />} />
            {/* <Route path="*" element={<Navigate to="" />} /> */}
            <Route path="/strategies" element={<DownloadStrategy />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/signedDoc" element={<DisclaimerDoc onlyLoad={true} onIsDocSigned={()=>{}} />} />

            {/* <Route path="/changeaccount" element={<Membership />} /> */}
          </Routes>
        </RootLayout>
      </div>
    </>
  );
};

export default RoutesSection;
